var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:["reset-button", { 'reset-button--show': _vm.status === 'Completed' }],attrs:{"src":require('@/assets/images/refresh-icon.svg'),"alt":"refresh icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }